import { Box } from '@mui/material';

import { HotelAvailabilitySearchLayout } from '@frontend/features/hotel/components/Availability';

// import { FeaturedSection } from '../../features/offers/components/FeaturedSection';
// import { OfferSection } from '../../features/offers/components/OfferSection';
import { useBreakpoints } from '../../features/common/hooks/useBreakpoints';

export const Hotels = () => {
  const { gap } = useBreakpoints();

  return (
    <Box display="flex" flexDirection="column" >
        <HotelAvailabilitySearchLayout />
    </Box>
  );
};
